import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../components/common/FormikControl";
import { useSelector } from "react-redux";
import { selectHighestCycle, selectManufacturehasNacycle } from "../../slices/manufacturer";
import { useEffect, useState } from "react";

  const Filter = ({ onApply, onClear, initialFilters  }) => {

  const initialValues = {
    phase_type: "",
    product: "",
    cycle: [],
    dashboardFilter: initialFilters?.dashboardFilter ?? false,
    ...initialFilters
  }
    const [cycleOptions, setCycleOptions] = useState([]);

const hasNaCycle = useSelector(selectManufacturehasNacycle);
const highestCycle = useSelector(selectHighestCycle); 
  const typeOptions = [
    { value: "PMS", label: 'PMS' },
    { value: "Commercial", label: 'Commercial' },
    { value: "Trial", label: 'Trial' },
  ]
const generateCycleOptions = (highestCycle, hasNaCycle) => {
  const options = [];
  if (hasNaCycle === 1) {
    options.push({
      value: "N/A",
      label: "N/A",
    });
  }
  const match = highestCycle?.match(/\d+/);
  if (match) {
    const max = parseInt(match[0], 10);
    for (let i = 1; i <= max; i++) {
      options.push({
        value: `Cycle ${i}`,
        label: `Cycle ${i}`,
      });
    }
  }
  return options;
};
    useEffect(() => {
      const options = generateCycleOptions(
        highestCycle,
        hasNaCycle
      );
      setCycleOptions(options);
    }, [hasNaCycle, highestCycle]);

  const handleCycleChange = (event) => {
    const selectedValues =
      typeof event.target.value === "string"
        ? event.target.value.split(",")
        : event.target.value;

    const filtered = Array.isArray(selectedValues)
      ? selectedValues.filter(Boolean)
      : [];
    formik.setFieldValue("cycle", filtered);
  };

  const formOptions = [
    {
      label: 'Type',
      type: 'checkbox',
      name: 'phase_type',
      options: typeOptions
    },
    {
      label: 'Cycle',
      type: 'select',
      multiple: true,
      name: 'cycle',
      placeholder: 'Select Cycle',
      options: cycleOptions,
      onChange: handleCycleChange,
    },
    {
      label: 'Dashboard Filter',
      type: 'switch',
      name: 'dashboardFilter',
      hideLabel: true
    }
  ]
  
  const handleSubmit = (values) => {
    onApply(values);
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })

  const handleClear = () => {
    formik.setValues({
      phase_type: "",
      product: "",
      cycle: [],
      dashboardFilter: false
    });
    onClear();
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key) => {
          const isDashboard = props.name === 'dashboardFilter';
          return (
            <Grid
              key={key}
              item
              xs={12}
              sx={isDashboard ? {
                background: '#F0F5FF',
                borderRadius: '8px',
                padding: '10px 12px',
                border: '1px solid #D6E4FF',
                marginBottom: '12px',
                marginTop: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                '& .MuiFormControlLabel-root': {
                  margin: 0,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row-reverse'
                }
              } : {}}
            >
              <FormikControl formik={formik} {...props} />
            </Grid>
          );
        })}
        
        <Box sx={{ display: "flex",justifyContent: "space-between", gap: 2, marginTop: "5px" }}>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  onClick={handleClear} variant="outlined">Clear Filter</LoadingButton>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  type="submit" variant="contained">Apply Filter</LoadingButton>
          </Box>
      </form>
    </Box>
  );
}

export default Filter;